import type { CSSValueWithLength } from '../../styles';
import type { StackProps as NewStackProps } from './Stack';
import type { StackProps as LegacyStackProps } from './types';

export type HorizontalAlignment = 'stretch' | 'leading' | 'trailing' | 'center';
export type VerticalAlignment = 'stretch' | 'top' | 'bottom' | 'center';

const HORIZONTAL_ALIGNMENT: Record<HorizontalAlignment, NonNullable<NewStackProps['align']>> = {
  stretch: 'stretch',
  leading: 'flex-start',
  trailing: 'flex-end',
  center: 'center',
};

const VERTICAL_ALIGNMENT: Record<VerticalAlignment, NonNullable<NewStackProps['align']>> = {
  stretch: 'stretch',
  top: 'flex-start',
  bottom: 'flex-end',
  center: 'center',
};

export interface OldVStackProps extends LegacyStackProps {
  /** @deprecated align을 대신 사용해주세요. */
  alignment?: HorizontalAlignment;
  /** @deprecated gap 또는 justify를 대신 사용해주세요. */
  spacing?: CSSValueWithLength;
}

export interface OldHStackProps extends LegacyStackProps {
  /** @deprecated align을 대신 사용해주세요. */
  alignment?: VerticalAlignment;
  /** @deprecated gap 또는 justify를 대신 사용해주세요. */
  spacing?: CSSValueWithLength;
}

function convertSpacing(spacing: CSSValueWithLength | undefined): Partial<Pick<NewStackProps, 'gap' | 'justify'>> {
  if (spacing === undefined) {
    return {};
  }

  if (spacing === 'auto') {
    return { justify: 'space-between' };
  }

  return { gap: spacing };
}

export function convertOldVStackProps({ alignment, spacing, ...props }: OldVStackProps): NewStackProps {
  return {
    ...props,
    direction: 'column',
    ...(alignment === undefined ? {} : { align: HORIZONTAL_ALIGNMENT[alignment] }),
    ...convertSpacing(spacing),
  };
}

export function convertOldHStackProps({ alignment, spacing, ...props }: OldHStackProps): NewStackProps {
  return {
    ...props,
    direction: 'row',
    ...(alignment === undefined ? {} : { align: VERTICAL_ALIGNMENT[alignment] }),
    ...convertSpacing(spacing),
  };
}
